/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VelocityRule
 */
export interface VelocityRule {
    /**
     * 
     * @type {number}
     * @memberof VelocityRule
     */
    windowSeconds: number;
    /**
     * Scan count that triggers the rule when exceeded within `windowSeconds`.
     * @type {number}
     * @memberof VelocityRule
     */
    maxScans: number;
    /**
     * 
     * @type {string}
     * @memberof VelocityRule
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof VelocityRule
     */
    id: string;
}

/**
 * Check if a given object implements the VelocityRule interface.
 */
export function instanceOfVelocityRule(value: object): value is VelocityRule {
    if (!('windowSeconds' in value) || value['windowSeconds'] === undefined) return false;
    if (!('maxScans' in value) || value['maxScans'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function VelocityRuleFromJSON(json: any): VelocityRule {
    return VelocityRuleFromJSONTyped(json, false);
}

export function VelocityRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): VelocityRule {
    if (json == null) {
        return json;
    }
    return {
        
        'windowSeconds': json['windowSeconds'],
        'maxScans': json['maxScans'],
        'displayName': json['displayName'],
        'id': json['id'],
    };
}

export function VelocityRuleToJSON(value?: VelocityRule | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'windowSeconds': value['windowSeconds'],
        'maxScans': value['maxScans'],
        'displayName': value['displayName'],
        'id': value['id'],
    };
}

